export const PRD_CONSTANTS = {
  MAX_TITLE_LENGTH: 512,
  // Throttle settings
  THROTTLE_DELAY: 1000,
  THROTTLE_OPTIONS: { leading: true, trailing: true },

  // Mermaid rendering
  MERMAID_RENDER_DELAY: 100,

  // UI dimensions
  MERMAID_VIEWER_HEIGHT: "350px",
  MONACO_EDITOR_HEIGHT: "220px",

  // Default values
  DEFAULT_FEATURE_TITLE: "Feature Title",
  DEFAULT_PRD_PLACEHOLDER: "Write your PRD here...",

  // URL patterns
  VALID_REPO_PATH_REGEX: /^[a-zA-Z0-9._-]+\/[a-zA-Z0-9._-]+$/,

  // Repository providers
  REPOSITORY_PROVIDERS: {
    GITHUB: "github",
    GITLAB: "gitlab",
    BITBUCKET: "bitbucket",
  },

  REPOSITORY_URLS: {
    GITHUB: "https://github.com/",
    GITLAB: "https://gitlab.com/",
    BITBUCKET: "https://bitbucket.org/",
  },
} as const;

export interface Project {
  id: string;
  repoPath?: string;
  provider?: string;
  labels?: Array<{
    id: string;
    label: string;
    name: string;
    color: { value: string };
  }>;
}

export interface Canvas {
  id: string;
  labels?: string[];
}

export interface FeaturePRD {
  id: string;
  title?: string | null;
  prd?: string | null;
  mermaid_diagram?: string | null;
  canvas_id?: string;
}

export interface LabelInterface {
  id: string;
  label: string;
  name: string;
  color: { value: string };
}
